module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getExpert) ? _c('div', {
    staticClass: "rules-banner"
  }, [(_vm.getSelectedEvent) ? _c('div', [(_vm.isEventToday(_vm.getSelectedEvent[0].start_date, _vm.getSelectedEvent[0].end_date)) ? _c('div', [_c('h2', [_vm._v("Hey, " + _vm._s(_vm.user.firstName) + ". Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.\n                "), _c('br'), _vm._v("How you would like to join the conversation?\n            ")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('0')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.joinEvent('1')
      }
    }
  }, [_vm._v("Shoe-cognito")])]) : _c('div', [_c('h2', [_vm._v("Hey, " + _vm._s(_vm.user.firstName) + ". Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.\n            ")]), _vm._v(" "), _c('h2', [_vm._v("Event will start here at "), _c('br'), _vm._v(" " + _vm._s(_vm.getDateReference(_vm.getSelectedEvent[0].start_date, 'live2')))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "rules-expert-content"
  }, [_c('h2', [_vm._v("about the expert")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert[0].name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getExpert[0].experties))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.getExpert[0].biography)
    }
  })]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "talkRulesHeading"
  }, [_c('h2', [_vm._v("Events Guidelines")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row marginTop rulerow"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/rule-one.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Keep it positive, supportive and respectful.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/rule-two.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Please be thoughtful and stay on topic.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/rule-three.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ruleImages"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/rule-four.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                        Please refer to TONE's "), _c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n                    ")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7020e578", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7020e578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Rules.vue